module.exports = __webpack_public_path__ + "static/media/059.ff5a94de.jpg";